import {
    FETCH_DIAGNOSIS_LIST_REQUEST,
    FETCH_DIAGNOSIS_LIST_SUCCESS,
    FETCH_DIAGNOSIS_LIST_FAILURE,
  } from "./FetchDiagnosisListTypes";
  
  const initialState = {
    loading: false,
    diagnosisList: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_DIAGNOSIS_LIST_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_DIAGNOSIS_LIST_SUCCESS:
        return {
          loading: false,
          diagnosisList: action.payload,
          error: "",
        };
      case FETCH_DIAGNOSIS_LIST_FAILURE:
        return {
          loading: false,
          diagnosisList: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  